import { Icon } from '@chakra-ui/react';

export const InstagramIcon = (props: any) => (
  <Icon data-testid="instagram-icon" {...props}>
    <path
      d="m7 4c-1.65685425 0-3 1.34314575-3 3v10c0 1.6568542 1.34314575 3 3 3h10c1.6568542 0 3-1.3431458 3-3v-10c0-1.65685425-1.3431458-3-3-3zm0-2h10c2.7614237 0 5 2.23857625 5 5v10c0 2.7614237-2.2385763 5-5 5h-10c-2.76142375 0-5-2.2385763-5-5v-10c0-2.76142375 2.23857625-5 5-5zm5 13c1.6568542 0 3-1.3431458 3-3s-1.3431458-3-3-3-3 1.3431458-3 3 1.3431458 3 3 3zm0 2c-2.76142375 0-5-2.2385763-5-5 0-2.76142375 2.23857625-5 5-5 2.7614237 0 5 2.23857625 5 5 0 2.7614237-2.2385763 5-5 5zm5-9c.5522847 0 1-.44771525 1-1s-.4477153-1-1-1-1 .44771525-1 1 .4477153 1 1 1z"
      fill="currentColor"
    />
  </Icon>
);
